import { Box, Button, ImageListItem, Stack, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import API from '../../../../services/API'
import BigModal from '../../../../components/Modals/BigModal'
import { LoadingSmall } from '../../../loading/loadingPage'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import Grid from '@mui/material/Grid'
import SmallModal from '../../../../components/Modals/SmallModal'
import { EPCRContext } from '../EPCR'

const SingleImage = ({ s3key, passedImage }) => {
  const { formValues, formID, setFormValues, setIsDraftDirty, setUploadState } =
    useContext(EPCRContext)
  const [image, setImage] = useState(null)
  const [loading, setLoading] = useState(true)
  const [openImage, setOpenImage] = useState(null)
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false)

  useEffect(() => {
    if (!s3key) {
      setLoading(false)
      return
    }
    setLoading(true)
    API.post('/gets3downloadurl', {
      key: s3key,
      ACL: 'public-read',
    })
      .then((res) => setImage(res.data))
      .finally(() => setLoading(false))
  }, [s3key])

  const handleDelete = () => {
    const keyToDelete = s3key ?? passedImage?.locals3key
    API.post('/deletes3object', { key: keyToDelete }).then((res) => {
      if (res.status === 200) {
        setOpenImage(false)
        setOpenConfirmDelete(false)
        setFormValues((prev) => ({
          ...prev,
          attachments: prev.attachments.filter((x) => {
            const currentKey = x.s3key ?? x.locals3key
            return currentKey !== keyToDelete
          }),
        }))
        setIsDraftDirty(true)
        setUploadState('pending')
      }
      API.put('/epcr/' + formID, {
        attachments: formValues.attachments.filter((x) => {
          const currentKey = x.s3key ?? x.locals3key
          return currentKey !== keyToDelete
        }),
      }).then((resAgain) => {
        if (resAgain.status === 200) {
          setIsDraftDirty(false)
          setUploadState('done')
        }
      })
    })
  }

  return (
    <Grid item xs={12} md={6} lg={4}>
      {loading ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <LoadingSmall />
        </Box>
      ) : (
        <Box
          height="100%"
          width="100%"
          display="flex"
          onClick={() => setOpenImage(image ?? passedImage?.localPreview)}
          sx={{ cursor: 'zoom-in' }}
        >
          <img
            src={passedImage?.localPreview ?? image}
            loading="lazy"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '100px',
              objectFit: 'cover',
              borderRadius: '8px',
            }}
          />
        </Box>
      )}
      <BigModal open={!!openImage} onClose={() => setOpenImage(null)}>
        <Stack gap={1}>
          <EPCRCard>
            <Box
              width="100%"
              height="400px"
              maxHeight="80vh"
              justifyContent="center"
              alignItems="center"
              sx={{
                backgroundImage: `url(${openImage})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            />
          </EPCRCard>
          <Button
            onClick={() => setOpenConfirmDelete(true)}
            fullWidth
            variant="outlined"
            color="error"
          >
            Delete
          </Button>
          <Button
            onClick={() => setOpenImage(null)}
            fullWidth
            variant="contained"
            color="error"
          >
            Close
          </Button>
        </Stack>
      </BigModal>
      <SmallModal
        open={openConfirmDelete}
        onClose={() => setOpenConfirmDelete(true)}
      >
        <Stack gap={1}>
          <Typography variant="subtitle1" textAlign="center">
            Are you sure you want to delete this Attachment?
          </Typography>
          <Button
            fullWidth
            variant="contained"
            color="success"
            onClick={() => handleDelete()}
          >
            Yes - Delete
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="error"
            onClick={() => setOpenConfirmDelete(false)}
          >
            No - Cancel
          </Button>
        </Stack>
      </SmallModal>
    </Grid>
  )
}

export default SingleImage
